import { gql } from '@apollo/client'
import { UserProfileInfoFragment } from './userProfile.queries'

export const FirmUserQuery = gql`
    query firmUserQuery($firmId: String, $userId: String) {
        user(firmId: $firmId, id: $userId) {
            email
            id
            role
            status
            userType
            isBestPracticeGroupEnabled
            isDesignatedAccountAdminUser
            profileInfo {
                firstName
                lastName
                professionalDiscipline
                professionalRole
            }
            isOnboarder
            userGroups {
                id
                name
            }
        }
    }
`
export const UserTAndCQuery = gql`
    query myTermsAcceptanceDate {
        myTermsAcceptanceDate
    }
`
export const ProfessionalDisciplinesQuery = gql`
    query disciplines {
        disciplines {
            id
            name
            roles
        }
    }
`

export const GetAllUsersQuery = gql`
    query getAllUsersQuery($input: GetResultsInput) {
        getAllUsers(input: $input) {
            count
            users {
                id
                email
                role
                status
                profileInfo {
                    ...userProfileInfoFragment
                }
                userGroups {
                    id
                    name
                }
            }
        }
    }
    ${UserProfileInfoFragment}
`

export const AdminGetAllUsersQuery = gql`
    query getAllUsersQuery($input: GetResultsInput) {
        getAllUsers(input: $input) {
            count
            users {
                role
                id
                email
                profileInfo {
                    ...userProfileInfoFragment
                }
                userGroups {
                    id
                    name
                }
            }
        }
    }
    ${UserProfileInfoFragment}
`
